import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { MobileNav } from './MobileNav';
import { CommandPalette } from '@/components/system/CommandPalette';
import { QuickDock } from '@/components/system/QuickDock';
import { DocumentDrawer } from '@/features/documents/DocumentDrawer';
import { Copilot } from '@/features/copilot/Copilot';
import { MfaGate } from '@/components/system/MfaGate';
import { LegalGate } from '@/components/system/LegalGate';
import { StepUpDialog } from '@/components/StepUpDialog';

import { useSession } from '@/stores/session';

// VLT-064: el guardián de sesión carga diferido — no pesa en el primer render
// (empezar a vigilar la inactividad un instante después no cambia nada).
const WhatsNewDialog = lazy(() => import('@/components/system/WhatsNewDialog').then((m) => ({ default: m.WhatsNewDialog })));
const SessionGuard = lazy(() => import('@/components/system/SessionGuard').then((m) => ({ default: m.SessionGuard })));

/** Responsive app shell: glass sidebar (desktop) + bottom nav (mobile).
 *  El menú se filtra por el rol real de la sesión (súper admin / firma / cliente). */
export function AppShell() {
  const role = useSession((s) => s.role);
  const { t } = useTranslation();
  return (
    <MfaGate>
    {/* Estándar Cassimmit 61 a 63: versión de términos sin aceptar = la app espera */}
    <LegalGate>
    <div className="flex min-h-dvh">
      {/* Primer tabstop: saltar sidebar+topbar directo al contenido (VLT-299) */}
      <a href="#contenido" className="skip-link">{t('a11y.skip')}</a>
      <Sidebar role={role} />
      <div className="flex min-w-0 flex-1 flex-col pb-[calc(5rem+env(safe-area-inset-bottom))] lg:pb-0">
        <Topbar />
        <main id="contenido" tabIndex={-1} className="flex-1 px-4 pb-8 outline-none lg:px-6 2xl:px-8">
          <Outlet />
        </main>
      </div>
      <MobileNav role={role} />
      <CommandPalette />
      <QuickDock />
      <Copilot />
      <DocumentDrawer />
      {/* VLT-355: desafío TOTP para descargas del vault (sesión aal1 con MFA) */}
      <StepUpDialog />
      {/* VLT-064: cierre por inactividad y caducidad de la sesión */}
      <Suspense fallback={null}><SessionGuard /></Suspense>
      {/* 4-nov: novedades sin ver + «Actualizar ahora» al abrir la app */}
      <Suspense fallback={null}><WhatsNewDialog /></Suspense>
    </div>
    </LegalGate>
    </MfaGate>
  );
}
